const TAB = 'tab';
const TABS = 'tabs';
const SIDEPANEL = 'sidepanel';
const CONTENT_GROUP = 'content-group';
const PANEL = 'panel';
const FAQ_PAGE = 'https://schema.org/FAQPage';

const CONTENT_GROUP_TYPES = Object.freeze({
  TAB: 'tab',
  SIDEPANEL: 'sidepanel',
  ACCORDION: 'accordion'
});

const OPEN_STATES = Object.freeze({
  FIRST_OPEN: 'first_open',
  ALL_CLOSED: 'all_closed',
  ALL_OPEN: 'all_open'
});

export { TAB, TABS, SIDEPANEL, CONTENT_GROUP, PANEL, CONTENT_GROUP_TYPES, OPEN_STATES, FAQ_PAGE };
